import React, { useState } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.core.css'

import Button from 'components/Button'
import { translation } from 'utils/germanTranslation'

const ChangeEmailTextScreen = ({ value, setValue }) => {
  const [editorValue, setEditorValue] = useState(value.emailText[0] || '')

  const handleChange = (newValue) => {
    setEditorValue(newValue)
    setValue({
      ...value,
      emailText: [
        newValue,
        ...value.emailText.slice(1),
      ],
    })
  }

  const modules = {
    toolbar: false,
  }

  return (
    <div className='bg-softWhite p-4 rounded-md'>
      <ReactQuill
        value={editorValue}
        onChange={handleChange}
        modules={modules}
        theme='core'
        className='h-[12rem] overflow-scroll overflow-x-hidden font-[Mulish]'
      />
      <div dangerouslySetInnerHTML={{ __html: value.emailText[1] || '' }}></div>
      <div dangerouslySetInnerHTML={{ __html: value.emailText[2] || '' }}></div>
      <div dangerouslySetInnerHTML={{ __html: value.emailText[3] || '' }}></div>

      <br />

      <h1 className='font-bold text-[13px]'>
        Wichtig: Der Zugriff auf das Profil erfolgt immer über diesen Link (nur
        diesen Link) – bitte löschen Sie diese E-Mail nicht, wenn Sie noch
        einmal darauf zugreifen möchten.
      </h1>

      <div className='flex items-center gap-3'>
        <Button
          title={translation.back}
          onClick={() =>
            setValue({
              ...value,
              showChangeEmailTextModal: false,
            })
          }
          containerClasses='bg-blue-200 px-4 py-2 rounded-lg mt-3'
        />
        <Button
          title='Speichern'
          onClick={() =>
            setValue({
              ...value,
              showChangeEmailTextModal: false,
            })
          }
          containerClasses='bg-blue-200 px-4 py-2 rounded-lg mt-3'
        />
      </div>
    </div>
  )
}

export default ChangeEmailTextScreen
